<template>
  <div
    class="shopping-container front-container d-flex justify-content-center align-items-center"
  >
    <div class="d-flex flex-column">
      <el-steps :active="active" align-center>
        <el-step title="確認商品"></el-step>
        <el-step title="資料填寫"></el-step>
        <el-step title="訂單結帳"></el-step>
      </el-steps>
      <router-view
        @insideNext="next"
        @insidePre="prev"
        @insideChangeActive="changeActive"
      ></router-view>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  mounted() {
    if (this.cartLength <= 0) {
      this.$router.push({ name: 'home' });
    }
  },
  data() {
    return {
      active: 1,
    };
  },
  computed: {
    ...mapState(['cartLength']),
  },
  methods: {
    changeActive(num) {
      this.active = num;
    },
    next() {
      if (this.active++ > 2) return;
      if (this.active === 1) {
        this.$router.push({ name: 'shoppingstep1' });
      }
      if (this.active === 2) {
        this.$router.push({ name: 'shoppingstep2' });
      }
      if (this.active === 3) {
        this.$router.push({ name: 'shoppingstep3' });
      }
    },
    prev() {
      if (this.active-- < 1) return;
      if (this.active === 1) {
        this.$router.push({ name: 'shoppingstep1' });
      }
      if (this.active === 2) {
        this.$router.push({ name: 'shoppingstep2' });
      }
      if (this.active === 3) {
        this.$router.push({ name: 'shoppingstep3' });
      }
    },
  },
  watch: {
    cartLength(cur) {
      if (cur <= 0) {
        this.$router.push({ name: 'products' });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
